import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  RichTextFieldSchema,
} from './Types';
import { z } from 'zod';

export enum SpotlightLayout {
  LeftAlternating = 'leftAlternating',
  RightAlternating = 'rightAlternating',
  LeftAll = 'leftAll',
  RightAll = 'rightAll',
}

export const SpotlightLayoutSchema = z.nativeEnum(SpotlightLayout);

export const SpotlightStyleSchema = z.object({
  backgroundColor: z.string(),
});
export type SpotlightStyle = z.infer<typeof SpotlightStyleSchema>;

export const SpotlightOptionsSchema = z.object({
  colorScheme: ColorSchemeSchema.optional(),
  layout: SpotlightLayoutSchema.optional(),
  preheaderEnabled: z.boolean().optional(),
  style: SpotlightStyleSchema.optional(),
  subheaderEnabled: z.boolean().optional(),
  entryCount: z.number().optional(),
});
export type SpotlightOptions = z.infer<typeof SpotlightOptionsSchema>;

export const SpotlightHeaderSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

export const SpotlightPreheaderSchema = RichTextFieldSchema.extend({
  name: z.literal('preheader'),
  role: z.literal(FieldRole.Preheader),
});

export const SpotlightSubheaderSchema = RichTextFieldSchema.extend({
  name: z.literal('subheader'),
  role: z.literal(FieldRole.Subheader),
});
export const SpotlightFeatureHeaderSchema = RichTextFieldSchema.extend({
  name: z.literal('featureHeader'),
  role: z.literal(FieldRole.Header),
});

export const SpotlightFeatureSubheaderSchema = RichTextFieldSchema.extend({
  name: z.literal('featureSubheader'),
  role: z.literal(FieldRole.Subheader),
});

export const SpotlightFeatureImageSchema = ImageFieldSchema.extend({
  name: z.literal('featureImage'),
  role: z.literal(FieldRole.Image),
});

const SpotlightFieldSchema = z.discriminatedUnion('name', [
  SpotlightHeaderSchema,
  SpotlightPreheaderSchema,
  SpotlightSubheaderSchema,
]);

export type SpotlightField = z.infer<typeof SpotlightFieldSchema>;

const FeatureFieldSchema = z.discriminatedUnion('name', [
  SpotlightFeatureHeaderSchema,
  SpotlightFeatureSubheaderSchema,
  SpotlightFeatureImageSchema,
]);

export type SpotlightFeatureField = z.infer<typeof FeatureFieldSchema>;

export const SpotlightFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(SpotlightFieldSchema),
});
export type SpotlightFieldGroup = z.infer<typeof SpotlightFieldGroupSchema>;

export const FeatureFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(FeatureFieldSchema),
});
export type FeatureFieldGroup = z.infer<typeof FeatureFieldGroupSchema>;

export const SpotlightBlockConfigSchema = z.object({
  options: SpotlightOptionsSchema,
  type: z.literal(BlockType.Spotlight),
  fieldGroups: z.tuple([SpotlightFieldGroupSchema]).rest(FeatureFieldGroupSchema),
  version: z.literal(2),
});
